import { render } from "./loading.vue?vue&type=template&id=1fb72984&scoped=true&ts=true"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"

import "./loading.vue?vue&type=style&index=0&id=1fb72984&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb72984"]])

export default __exports__